export default __webpack_public_path__ + "static/media/2023.7aced0f1.png";